import {
    useEffect,
    useState,
    useRef,
    forwardRef,
    useImperativeHandle,
    useCallback,
} from 'react'
import WebViewer from '@pdftron/webviewer'
import { saveFile } from '../utils/utils'
import save from '../icons/Save.svg'
import { useAuthInfo } from '@propelauth/react'
import { useWebViewer } from '../contexts/WebViewerContext'

const WebViewComponent = forwardRef(
    (
        {
            hasLink,
            initialFile,
            fileKey,
            id,
            onTextSelected,
            selectedText = null,
            page = 1,
            isTemplate = false,
            filename = '',
            extensionOverride=null
        },
        ref
    ) => {
        const { setWebViewerInstance } = useWebViewer()

        const viewer = useRef(null)
        
        const [pageNumber, setPageNumber] = useState(null)
        const [instance, setInstance] = useState(null)
        const [isActionButtonAdded, setIsActionButtonAdded] = useState(false) // Step 1: New state variable
        var buttonNeeded = true

        // Store page as a ref to maintain the latest value across renders
        const pageRef = useRef(page)

        // Update ref when prop changes
        useEffect(() => {
            pageRef.current = page
        }, [page])

        const authInfo = useAuthInfo()

        const orgs = authInfo.orgHelper.getOrgs()

        async function getOrgAccessToken(orgId) {
            const orgAccessToken = await authInfo.tokens.getAccessTokenForOrg(
                orgId
            )
            // console.log('orgAccessToken', orgAccessToken)
            return orgAccessToken
        }

        // Make the method accessible from the parent component
        useImperativeHandle(ref, () => ({
            getText: () => {
                return { selectedText, pageNumber }
            },
        }))

        useEffect(() => {            
            try {

                WebViewer(
                    {
                        path: '/public',
                        licenseKey: process.env.REACT_APP_APRYSE_KEY,
                        initialDoc: initialFile,
                        loadAsPDF: true,
                        disabledElements: ['searchPanel'],
                        extension:  extensionOverride? extensionOverride : null
                    },
                    viewer.current
                )
                    .then((i) => {
                        setWebViewerInstance(i)
                        try {
                            const { UI } = i


                            // Removing this due to error, may need to readd
                            // if (initialFile.includes('pdf')) {
                            //     UI.setFitMode(UI.FitMode.FitWidth)
                            // } else {
                            //     UI.setZoomLevel(0.5)
                            // }

                            setInstance(i)

                            if (!i || !i.Core || !i.Core.documentViewer) {
                                console.error(
                                    'WebViewer initialized without proper components'
                                )
                                return
                            }

                            const {
                                documentViewer,
                                Annotations,
                                annotationManager,
                                Tools,
                            } = i.Core

                            documentViewer.setSearchHighlightColors({
                                searchResult: new Annotations.Color(
                                    0,
                                    0,
                                    255,
                                    0.5
                                ),
                                activeSearchResult: 'rgba(0, 255, 0, 0.5)',
                            })

                            const showSelectedText = () => {
                                const page = documentViewer.getCurrentPage()
                                console.log('page', page)
                                const text =
                                    documentViewer.getSelectedText(page)
                                if (text) {
                                    console.log('text', text)
                                }
                            }

                            documentViewer.addEventListener(
                                'keyDown',
                                function (e) {
                                    if (
                                        e.keyCode == 67 &&
                                        (e.ctrlKey || e.metaKey)
                                    ) {
                                        showSelectedText()
                                        console.log('Ctrl+C pressed')
                                    }
                                }
                            )

                            documentViewer.addEventListener(
                                'documentLoaded',
                                () => {
                                    console.log('doc Loaded HERE')
                                    
                                    i.UI.disableElements(['searchPanel'])
                                    
                                    console.log(
                                        'Setting page to:',
                                        pageRef.current
                                    )

                                    const textSelectedListener = (
                                        quads,
                                        text,
                                        page
                                    ) => {
                                        if (text && text.length > 0) {
                                            setPageNumber(page)
                                        }
                                    }

                                    // Add event listener only if documentViewer is defined
                                    if (documentViewer) {
                                        documentViewer.addEventListener(
                                            'textSelected',
                                            textSelectedListener
                                        )
                                    }

                                    // Force wait for document to be fully loaded
                                    setTimeout(() => {
                                        try {
                                            // Make sure documentViewer is still available
                                            if (documentViewer) {
                                                // Convert to number and ensure it's valid
                                                const pageToGo = Number(
                                                    pageRef.current
                                                )
                                                if (
                                                    !isNaN(pageToGo) &&
                                                    pageToGo > 0
                                                ) {
                                                    console.log(
                                                        'Navigating to page:',
                                                        pageToGo
                                                    )
                                                    documentViewer.setCurrentPage(
                                                        pageToGo
                                                    )
                                                } else {
                                                    console.log(
                                                        'Invalid page number:',
                                                        pageRef.current
                                                    )
                                                }
                                            } else {
                                                console.log(
                                                    'Document viewer no longer available'
                                                )
                                            }
                                        } catch (error) {
                                            console.error(
                                                'Error setting page:',
                                                error
                                            )
                                        }
                                    }, 100) // Increased timeout for more reliability

                                    const newLink = new Annotations.Link()
                                    newLink.PageNumber = 7
                                    newLink.X = 100
                                    newLink.Y = 95
                                    newLink.Width = 200
                                    newLink.Height = 100
                                    newLink.StrokeStyle = 'underline'
                                    newLink.StrokeThickness = 2

                                    const pageToLinkTo = 28

                                    // newLink.addAction(
                                    //   'U',
                                    //   new Actions.GoTo({
                                    //     dest: new Actions.GoTo.Dest({
                                    //       page: pageToLinkTo,
                                    //     }),
                                    //   }),
                                    // );
                                    // console.log('hasLink', hasLink)

                                    if (hasLink) {
                                        annotationManager.addAnnotation(newLink)
                                        annotationManager.drawAnnotationsFromList(
                                            newLink.PageNumber
                                        )
                                    }

                                    i.UI.setHeaderItems((header) => {
                                        if (buttonNeeded) {
                                            console.log('pushing itemm!')
                                            header.push({
                                                type: 'actionButton',
                                                img: save,
                                                onClick: async () => {
                                                    // onVectorizationStart()
                                                    const orgAccessToken =
                                                        await getOrgAccessToken(
                                                            orgs[0].orgId
                                                        )
                                                    const doc =
                                                        documentViewer.getDocument()
                                                    console.log(
                                                        'doc',
                                                        initialFile
                                                    )
                                                    const data =
                                                        await doc.getFileData(
                                                            {}
                                                        )
                                                    const arr = new Uint8Array(
                                                        data
                                                    )
                                                    const blob = new Blob([arr])
                                                    await saveFile(
                                                        id,
                                                        blob,
                                                        orgAccessToken
                                                    )
                                                },
                                            })
                                            buttonNeeded = false
                                        }
                                    })

                                    // for initial search
                                    if (selectedText !== null && !isTemplate) {
                                        console.log('selectedText', selectedText)

                                        const searchOptions = {
                                            caseSensitive: false,
                                            wholeWord: false,
                                            wildcard: false,
                                            regex: false,
                                            searchUp: true,
                                            ambientString: false,
                                        }
                                        setTimeout(() => {
                                            i.UI.searchText(
                                                selectedText,
                                                searchOptions
                                            )
                                        }, 1500)
                                    }

                                    return () => {
                                        if (documentViewer) {
                                            documentViewer.removeEventListener(
                                                'textSelected',
                                                textSelectedListener
                                            )
                                        }
                                    }
                                }
                            )
                        } catch (innerError) {
                            console.error(
                                'Error initializing WebViewer components:',
                                innerError
                            )
                        }
                    })
                    .catch((error) => {
                        console.error('Error initializing WebViewer:', error)
                    })
            } catch (error) {
                console.error('Error setting up WebViewer:', error)
            }
        }, [])

        useEffect(() => {
            if (instance) {
                setIsActionButtonAdded(true)
                console.log('Loading new document:', initialFile)
                console.log('With page number:', pageRef.current)

                let loadOptions = {
                    extension: (initialFile && initialFile.includes('pdf')) ? 'pdf' : 'docx',
                    filename: filename.split('/').pop().slice(0, 15) + '...'
                }

                if (extensionOverride) {
                    console.log("overriding filetype")
                    loadOptions['extension'] = extensionOverride
                }

                try {
                    // Load the document without using .then()
                    instance.UI.loadDocument(initialFile, loadOptions)
                    if (initialFile.includes('pdf')) {
                        instance.UI.setFitMode(instance.UI.FitMode.FitWidth)
                    } else {
                        instance.UI.setZoomLevel(0.5)
                    }

                    // Use a timeout to wait for document to load instead of .then()
                    // setTimeout(() => {
                    try {
                        if (
                            instance &&
                            instance.Core &&
                            instance.Core.documentViewer
                        ) {
                            const pageToGo = Number(pageRef.current)
                            if (!isNaN(pageToGo) && pageToGo > 0) {
                                console.log(
                                    'Setting page after reload:',
                                    pageToGo
                                )
                                instance.Core.documentViewer.setCurrentPage(
                                    pageToGo
                                )
                            }
                        } else {
                            console.log('Document viewer not available yet')
                        }
                    } catch (error) {
                        console.error(
                            'Error setting page after reload:',
                            error
                        )
                    }
                    // }, 2000) // Longer timeout to ensure document is loaded
                } catch (error) {
                    console.error('Error loading document:', error)
                }
            }
        }, [initialFile, instance, fileKey])

        // for subsequent searches
        useEffect(() => {
            if (selectedText !== null && selectedText !== '' && instance) {
                const searchOptions = {
                    caseSensitive: false,
                    wholeWord: false,
                    wildcard: false,
                    regex: false,
                    searchUp: true,
                    ambientString: false,
                }

                // Add a 1-second delay before performing the text search
                const timeoutId = setTimeout(() => {
                    instance.UI.searchTextFull(selectedText, searchOptions)
                }, 1000)

                // Cleanup function to clear the timeout if selectedText changes
                return () => clearTimeout(timeoutId)
            }
        }, [selectedText, instance])

        return (
            <div className="MyComponent">
                <div className="webviewer" ref={viewer}></div>
            </div>
        )
    }
)

export default WebViewComponent
